import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

/**
 * Confirmation overlay shown when closing the AI snippets modal would discard
 * unsaved edits.
 */
export const UnsavedChangesGuard: FunctionComponent<{
	onCancel: () => void;
	onConfirm: () => void;
}> = ({ onCancel, onConfirm }) => {
	const { t } = useTranslation();

	return (
		<div className="fixed inset-0 z-[2100] flex items-center justify-center bg-[rgba(17,24,39,0.45)]">
			<div className="w-[min(420px,92vw)] bg-white rounded-xl shadow-2xl p-6">
				<div className="text-[15px] font-semibold text-text mb-1.5">
					{t("aiSnippet.modal.footer.unsavedChanges")}
				</div>
				<div className="text-sm text-text-meta mb-4">
					{t("aiSnippet.modal.footer.unsavedChangesBody")}
				</div>
				<div className="flex justify-end gap-2">
					<button
						className="px-3.5 py-2 bg-white border border-border-light rounded-lg font-medium text-sm text-text cursor-pointer hover:bg-background-light"
						type="button"
						onClick={onCancel}
					>
						{t("aiSnippet.modal.footer.cancel")}
					</button>
					<button
						className="px-3.5 py-2 bg-status-error text-white border-0 rounded-lg font-semibold text-sm cursor-pointer hover:opacity-90"
						type="button"
						onClick={onConfirm}
					>
						{t("aiSnippet.modal.footer.unsavedChangesConfirm")}
					</button>
				</div>
			</div>
		</div>
	);
};
